import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../utils/cn';
export function Logo({
  to = '/',
  className
}: {
  to?: string;
  className?: string;
}) {
  return <Link to={to} className={cn('group inline-flex items-baseline gap-[3px] whitespace-nowrap', className)} aria-label="Pan & Apron — home" data-id="element-837" data-mp="tbtc2ig8m96h">
      <span className="font-display text-[19px] font-semibold leading-none tracking-[-0.02em] text-ink" data-id="element-838" data-mp="ocgry5gr3g7l">Pan</span>
      <span className="font-display text-[19px] font-semibold leading-none tracking-[-0.02em] text-action transition-colors duration-150 ease-out group-hover:text-accent" aria-hidden="true" data-id="element-839" data-mp="kd7yl1pmhkck">
        &amp;
      </span>
      <span className="font-display text-[19px] font-semibold leading-none tracking-[-0.02em] text-ink" data-id="element-840" data-mp="5mqv7ctfgkd1">Apron</span>
    </Link>;
}